'use client'
import { motion } from 'motion/react'
import { useSlate } from 'slate-react'
import React from 'react'
import {
  BlockType,
  isBlockActive,
  toggleBlock,
} from '../components/list-transforms'

export const BlockList = ({
  format,
  className,
  children,
}: {
  format: BlockType
  children: React.ReactNode
  className?: string
}) => {
  const editor = useSlate()
  const isActive = isBlockActive(editor, format)

  return (
    <motion.div className={'my-auto'} whileTap={{ scale: 0.95 }}>
      <button
        type={'button'}
        className={`toolbar-button ${isActive ? 'active' : ''}${className ? ` ${className}` : ''}`}
        onMouseDown={(event) => {
          event.preventDefault()
          toggleBlock(editor, format)
        }}>
        {children}
      </button>
    </motion.div>
  )
}
